var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSustainablePartnerships(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.06807 -.094852)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.071 .095)",
    d: "m30.141 13.156c-3.7299-0.0012-8.041 0.11881-10.371 2.1016-0.942 0.802-2.1102 1.863-3.6152 2.791-1.92 1.186-4.373 2.1621-7.459 2.1621h-8.4844c0.11142 0.89738 0.28952 1.7743 0.53125 2.625h7.9355c7.005 0 11.294-4.4101 11.85-4.7871 3.943-2.67 7.1569-2.2656 11.17-2.2656h4.082c-0.11463-0.89715-0.29612-1.7728-0.54102-2.623h-3.541c-0.50162 0-1.0238-0.0037-1.5566-0.0039z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.071 .095)",
    d: "m0.74414 13.213c-0.24222 0.85097-0.41941 1.7273-0.53125 2.625h8.502c3.073 0 5.5449 0.98602 7.4609 2.166 1.516 0.932 2.6142 2.0452 3.6152 2.7852 3.501 2.588 7.9147 1.9961 11.928 1.9961h3.5508c0.23903-0.85099 0.41663-1.7277 0.52539-2.625h-4.0781c-4.012 0-7.2269 0.51766-11.17-2.1523-0.556-0.377-4.8437-4.7949-11.848-4.7949z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainablePartnerships);
export default __webpack_public_path__ + "static/media/sustainable_partnerships.05a72c60fb73e29f519603953d59f5e5.svg";
export { ForwardRef as ReactComponent };